import { createSlice } from "@reduxjs/toolkit"

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    products: [],
    quantity: 0,
    total: 0,
  },
  reducers: {
    addProduct: (state, action) => {
      state.products = state.products.filter((product) => {
        return product.id !== action.payload.id
      })
      state.products.push(action.payload)

      state.total = state.products.reduce((prev, product) => {
        return prev + product.price * product.quantity
      }, 0)
      state.quantity = state.products.length
    },
  },
})

export const { addProduct } = cartSlice.actions
export default cartSlice.reducer
